import * as React from 'react';

const About = () => <p>About page</p>;

export default About;
